import { LanguageContext } from 'Contexts/LanguageContext';
import React, { useContext } from 'react';

const useLanguage = () => {
    return useContext(LanguageContext);
}

export default useLanguage;